// frontend/src/hooks/useRegistrationValidation.ts
import { useContext, useCallback} from 'react';
import { RegistrationValidationContext } from '../pages/CompetitionRegistrationPage';
import { handleApiError } from '../utils/apiErrorHandler';

/**
 * Hook to access and update registration validation state
 * Use this hook in any component that modifies registration data
 * to ensure the validation UI is updated
 */
export const useRegistrationValidation = () => {
  const context = useContext(RegistrationValidationContext);
  
  if (!context) {
    throw new Error('useRegistrationValidation must be used within the CompetitionRegistrationPage');
  }
  
  // Wrap refreshValidation in a try-catch to make it more robust
  const refreshAndNotify = useCallback(async () => {
    try {
      context.refreshValidation();
    } catch (error) {
      handleApiError(error, `Fehler beim Aktualisieren der Validierung.`);      
    }
  }, [context.refreshValidation]);
  
  return {
    errors: context.errors,
    warnings: context.warnings,
    refreshValidation: refreshAndNotify
  };
};